import React from 'react'

import FiltersMolecule from '@/molecules/Filters'

const Filters = (props) => (
  <FiltersMolecule {...props} />
)

export default Filters
